import { Accordion, Center, Group, Modal, ScrollArea, Stack, Text, useMantineTheme } from '@mantine/core';

import { useParams } from 'react-router-dom';

import { useDisclosure } from '@mantine/hooks';

import { useCallback, useState } from 'react';

import { IconChevronRight } from '@tabler/icons-react';

import OpportunityAssessmentListItem from './OpportunityAssessmentListItem';
import { CenteredLoader, Pagination } from '../../../components';
import classes from './OpportunityAccordion.module.css';
import useOpportunityAssessmentListData from '../../../hooks/useOpportunityAssessmentListData';
import { FastDraftSetup } from '../../../components/Modals';
import { defaultModalProps } from '../../../utils/mantineUtils';

import { type Opportunity, type WithoutPermissions } from '../../../types/apiTypes';
const OpportunityAssessmentList: React.FC = () => {
  const { organization } = useParams();

  const {
    opportunityAssessments,
    isLoading,
    pageCount,
    pagination,
    setPageIndex
  } = useOpportunityAssessmentListData(organization ?? '');

  const [fastDraftSetupOpened, fastDraftSetupHandlers] = useDisclosure();
  const { colors, other: colorVars } = useMantineTheme();
  const [currentOpportunity, setCurrentOpportunity] = useState<WithoutPermissions<Opportunity>>();
  const onOpenFastDraft = useCallback((opportunity?: WithoutPermissions<Opportunity>) => {
    setCurrentOpportunity(opportunity);
    fastDraftSetupHandlers.open();
  }, []);

  const header = (
    <Group justify='space-between' mb={16}>
      <Text fz='sm'>
        Result
      </Text>
      <Group mr={54} gap={28}>
        <Text fz='sm'>
          Score
        </Text>
        <Text fz='sm'>
          Recommendation
        </Text>
      </Group>
    </Group>
  );

  const emptyState = (
    <Center flex={1} h='100%' style={{ border: `1px solid ${colors.gray[4]}`, borderRadius: 4 }}>
      <Text >
        No evaluations to display
      </Text>
    </Center>);

  if (isLoading) {
    return (
      <CenteredLoader h='100%' />
    );
  }
  return (
    <Stack flex={1} h='100%' gap={0} miw={0}>
      <Modal opened={fastDraftSetupOpened} {...defaultModalProps} size={1000}>
        <FastDraftSetup
          onClose={fastDraftSetupHandlers.close}
          opportunityUid={currentOpportunity?.uid}
        />
      </Modal>
      {header}
      {opportunityAssessments?.length === 0
        ? emptyState
        : (
          <ScrollArea h='100%'>
            <Accordion
              variant='contained'
              chevron={<IconChevronRight color={colorVars.primaryIconColor} />}
              chevronSize={24}
              chevronPosition="left"
              classNames={{
                root: classes.root,
                control: classes.control,
                label: classes.label,
                chevron: classes.chevron,
                item: classes.item
              }}
            >
              {opportunityAssessments?.map((assessment) => (
                <OpportunityAssessmentListItem
                  key={assessment.uid} assessment={assessment}
                  onOpenFastDraft={onOpenFastDraft}
                />))}
            </Accordion>
          </ScrollArea>
          )}
      <Pagination
        total={pageCount}
        onChange={(value) => { setPageIndex(value - 1); }}
        value={pagination.pageIndex + 1}
        mt={16}
        mb={0}
      />
    </Stack>
  );
};

export default OpportunityAssessmentList;
